
import Vue from "vue";
import { View } from "@/models/view";
import { AuthService, DossierService } from "@/services";
import AppViewShareModal from "./ViewShareModal.vue";

export default Vue.extend({
	data(){
		return {
			toEditSharesView: null as null | View,
			DossierService
		};
	},
	props: {
		title: {
			type: String
		},
		views: {
			type: Array as () => View[],
			required: true
		},
		showShareButton: Boolean
	},
	methods: {
		createNewView() {
			this.$emit("new-clicked");
		},
		editClicked(view: View) {
			this.$emit("edit-clicked", view);
		},
		async deleteView(view: View) {
			let confirm = await this.$wf.confirm(this.$ct("confirmDeleteView",
				{viewName: view.Name}),
				this.$t("common.yes"), this.$t("common.no"), this.$t("common.warning"), "warning");
			if (!confirm) {
				return;
			}
			this.$emit("delete-clicked", view);
		},
		isOwnedView(view:View):boolean {
			return view.UserID == AuthService.wfUser.ID;
		},
		sharedByText(view:View):string {
			let user = this.DossierService.users.find(u=>u.ID == view.UserID);
			if (!user) {
				return this.$ct("shared-with-you").toString();
			}
			return this.$ct("shared-by", {name: user.getShortDisplayName()}).toString();
		},
		editShares(view:View){
			this.toEditSharesView=view;
		}
	},
	async created(){
		if (this.showShareButton) {
			await this.DossierService.getUsers();
		}
	},
	components: {
		AppViewShareModal
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
